export const get_options_eq = t => {
  const options_eq = [
    { value: '上月', label: '上月' },
    { value: '本月', label: '本月' },
    { value: '今日', label: '今日' },
    { value: '昨日', label: '昨日' },
    { value: '期初', label: '期初' },
  ];
  return {
    options_eq,
  };
};
